"use client";

type Cell = { count: number; amount: number };
type Matrix = Cell[][];

const COLS = 24;
const ROWS = 7;
const LABELS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

type Props = {
  matrix: Matrix;
  maxAmount: number;
  /** Heat scale tuned for dark page background when true. */
  darkMode?: boolean;
};

export function HourlyHeatmap({ matrix, maxAmount, darkMode = false }: Props) {
  const max = maxAmount > 0 ? maxAmount : 1;

  function bg(d: number, h: number): string {
    const v = matrix[d]?.[h]?.amount ?? 0;
    const t = Math.min(1, v / max);
    if (darkMode) {
      const s = 35 + t * 55;
      const l = 16 + t * 52;

      return `hsl(217 ${s}% ${l}%)`;
    }
    const r = Math.round(30 + t * 180);
    const g = Math.round(80 + t * 100);
    const b = Math.round(180 - t * 80);

    return `rgb(${r},${g},${b})`;
  }

  return (
    <div className="overflow-x-auto">
      <div className="inline-flex flex-col gap-0.5 text-[10px]">
        <div className="flex gap-0.5">
          <div className="w-8 shrink-0" />
          {Array.from({ length: COLS }, (_, h) => (
            <div
              key={h}
              className="w-3 shrink-0 text-center text-muted-foreground leading-none"
              title={`${h}:00`}
            >
              {h % 6 === 0 ? h : ""}
            </div>
          ))}
        </div>
        {Array.from({ length: ROWS }, (_, d) => (
          <div key={d} className="flex gap-0.5 items-center">
            <div className="w-8 shrink-0 font-medium text-muted-foreground">
              {LABELS[d]}
            </div>
            {Array.from({ length: COLS }, (_, h) => {
              const cell = matrix[d]?.[h];
              return (
                <div
                  key={h}
                  className="h-4 w-3 shrink-0 rounded-sm border border-border/40"
                  style={{ backgroundColor: bg(d, h) }}
                  title={`${LABELS[d]} ${h}:00 — ₹${(cell?.amount ?? 0).toFixed(0)} (${cell?.count ?? 0} bills)`}
                />
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}
